import ProgressiveImage from "react-progressive-image-loading"
import { ModalContent } from "./ModalContent"
import { FaAndroid, FaStar } from "react-icons/fa"
import { getOfferWallName, getWallName, hideDailyStreakModal, numberWithCommas, submitFingersWall } from "../../components/utils"
import { GiSandsOfTime } from "react-icons/gi"
import { IoCheckmarkDoneCircle } from "react-icons/io5"
import { useEffect, useState } from "react"
import { socket } from "../../components/Containers/MainContainer"
import fingerprintjs from '@fingerprintjs/fingerprintjs';

export const DailyStreakModalContent = (props) => {

    return (
        <ModalContent
        click={hideDailyStreakModal}
        hideTitle={true}
        hide={true}
        title={``}
        className={`modal-content-login modal-content-daily-streak`}
        content={
            <>
                <div className="daily-streak-info-content">
                    <div className="daily-streak-header">
                        <h2>7-Day Streak Rewards</h2>
                        
                    </div>

                    <div className="daily-streak-description">
                        <p>Earn escalating bonuses by consistently achieving at least 1,000 coins daily for seven consecutive days. The longer your streak, the higher your bonus.</p>
                    </div>

                    <div className="daily-streak-section">
                        <h3>How to Earn</h3>
                        <p>
                            Complete <span className="daily-streak-link" onClick={() => {
                                props.click();
                                if (props.onNavigateOffers) props.onNavigateOffers();
                            }}>offers</span> or <span className="daily-streak-link" onClick={() => {
                                props.click();
                                if (props.onNavigateSurveys) props.onNavigateSurveys();
                            }}>surveys</span> to maintain your daily streak and unlock rewards.
                        </p>
                    </div>

                    <div className="daily-streak-section">
                        <h3>Day 7 Reward</h3>
                        <p>
                            On Day 7, you have a 2% chance to earn a maximum reward of $7.5 or a 98% chance to earn $0.55.
                        </p>
                    </div>
                </div>
          </>
        }/>
    )
}